export default __webpack_public_path__ + "static/media/axion-today-white.5efbe4db.png";